
import Vue from 'vue'
import * as Api from '@/api/CartApi'
import { ExpandingPanel, Currency } from '@/components'
import { Textbox } from '@/components/formGroups'
import { SaveButton } from '@/components/buttons'
import { ProductStoreItemModel } from '@ViewModels/ProductStoreItemModel'

export default Vue.extend({
   name: 'QuickAdd',
   data() {
      return {
         searching: false,
         addingToCartProductPriceId: '',
         productCode: '',
         product: null as ProductStoreItemModel | null,
         errorMessage: '',
      }
   },
   computed: {
      currencyCode(): string {
         return this.$store.getters.currencyCode
      },
   },
   methods: {
      addingToCart(productPriceId: string): boolean {
         return this.addingToCartProductPriceId === productPriceId
      },
      async search() {
         this.searching = true
         this.product = null
         const result = await Api.quickAddSearch(this.productCode)
         if (result) {
            this.product = result
            this.errorMessage = ''
         } else {
            this.errorMessage = 'No matching products found'
         }
         this.searching = false
      },
      async addToCart(productPriceId: string) {
         this.addingToCartProductPriceId = productPriceId
         const success = await this.$store.dispatch('updateCartQuantity', {
            productPriceId,
            quantity: 1,
         })
         if (success) {
            this.product = null
            this.productCode = ''
         }
         this.addingToCartProductPriceId = ''
      },
   },
   components: {
      Textbox,
      Currency,
      SaveButton,
      ExpandingPanel,
   },
})
